import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 20 19"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.033 4.865h-5.93a.436.436 0 1 1 0-.873h5.93l-2.747-2.747a.436.436 0 1 1 .617-.617l3.484 3.484a.435.435 0 0 1 .002.632l-3.486 3.485a.436.436 0 1 1-.617-.617l2.747-2.747Zm-4.761 7.885c0-.23.186-.417.416-.417 1.149 0 2.297.093 3.445.28a1.665 1.665 0 0 1 1.336 1.188l.259.91.007.024.005.02.013.055c.193.88-.38 1.745-1.25 1.98-.837.227-1.783.4-2.538.483a.417.417 0 0 1-.46-.368 13.384 13.384 0 0 0-.447-2.095c-.187-.602-.434-1.182-.6-1.575-.11-.26-.186-.438-.186-.485ZM11.188 9a2.501 2.501 0 0 1 3.279-2.376l-.065.104a1.686 1.686 0 0 0 1.732 2.79A2.501 2.501 0 0 1 11.188 9ZM7.022 19c-2.481 0-4.305-.235-5.486-.718a1.667 1.667 0 0 1-1.004-1.868l.324-1.624a2.917 2.917 0 0 1 2.613-2.336c.949-.08 2.132-.12 3.553-.12 1.42 0 2.604.04 3.552.12a2.917 2.917 0 0 1 2.613 2.336l.324 1.624a1.667 1.667 0 0 1-1.004 1.868c-1.181.483-3.004.718-5.485.718ZM3.688 7.333A3.335 3.335 0 0 1 7.022 4a3.335 3.335 0 0 1 3.333 3.333 3.336 3.336 0 0 1-3.333 3.334 3.335 3.335 0 0 1-3.334-3.334Z",
      clipRule: "evenodd"
    }
  )
);
var SvgQueueTransferFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var QueueTransferFilled_default = SvgQueueTransferFilled;

export { QueueTransferFilled_default as default };
